export const getUrl = (locationDetails: any, url: string) => {
  if ((locationDetails || []).length > 1) {
    if (url.includes('login')) {
      return `/${url}`;
    } else {
      return `/select-location-page`;
    }
  } else {
    return `/${url}`;
  }
};
export const getDynamicUrl = (url: string, state: string, city: string) => {
  if (url.includes('pay') || url.includes('login')) {
    return `${state.toLowerCase()}/${city.toLowerCase()}/account/login`;
  } else if (url.includes('reserve') || url.includes('view-rates')) {
    return `${state.toLowerCase()}/${city.toLowerCase()}/view-rates`;
  } else {
    return `${url}`;
  }
};

export const removeLastUrlPart = (url: string) => {
  const urlArr = url.split('/');
  urlArr.pop();
  return urlArr.join('/');
};
